// Error tracking utility for Google Analytics

/**
 * Track JavaScript errors to Google Analytics
 */
export const trackError = (error, errorInfo = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'exception', {
      description: error?.message || 'Unknown error',
      fatal: errorInfo?.fatal || false,
      error_type: error?.name || 'Error',
      error_stack: error?.stack?.substring(0, 150) || 'No stack trace',
      component_stack: errorInfo?.componentStack?.substring(0, 150) || '',
      page: window.location?.pathname
    });
  }

  // Also log to console in development
  if (import.meta.env?.DEV) {
    console.error('Error tracked:', error, errorInfo);
  }
};

/**
 * Track validation errors
 */
export const trackValidationError = (fieldName, errorMessage, formName) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'validation_error', {
      field_name: fieldName,
      error_message: errorMessage,
      form_name: formName,
      page: window.location?.pathname
    });
  }
};

/**
 * Track API/submission errors
 */
export const trackSubmissionError = (errorType, errorMessage, context = {}) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'submission_error', {
      error_type: errorType,
      error_message: errorMessage,
      context: JSON.stringify(context)?.substring(0, 100),
      page: window.location?.pathname
    });
  }
};

/**
 * Track component render errors
 */
export const trackComponentError = (componentName, error, errorInfo) => {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', 'component_error', {
      component_name: componentName,
      error_message: error?.message || 'Unknown error',
      error_stack: error?.stack?.substring(0, 150) || '',
      component_stack: errorInfo?.componentStack?.substring(0, 150) || '',
      page: window.location?.pathname
    });
  }
};
